module.exports = {"130225001":"乐安街道","130225100":"乐亭镇","130225101":"汤家河镇","130225102":"胡家坨镇","130225104":"阎各庄镇","130225105":"马头营镇","130225106":"新寨镇","130225107":"汀流河镇","130225108":"姜各庄镇","130225109":"毛庄镇","130225110":"中堡镇","130225201":"庞各庄乡","130225202":"大相各庄乡","130225203":"古河乡","130225453":"河北乐亭经济开发区","130225454":"乐亭县城区工业聚集区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130225.json
// module id = 90
// module chunks = 0